import { render, staticRenderFns } from "./ZhongYi.vue?vue&type=template&id=4f2b1dc2&scoped=true&"
import script from "./ZhongYi.vue?vue&type=script&lang=js&"
export * from "./ZhongYi.vue?vue&type=script&lang=js&"
import style0 from "./ZhongYi.vue?vue&type=style&index=0&id=4f2b1dc2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2b1dc2",
  null
  
)

export default component.exports